/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Langues } from '../models/langues';


/**
 * Fonctions de gestion des formulaires
 */
@Injectable({
  providedIn: 'root',
})
export class FormulairesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation formulaireGetCodesAccesVisiteurPp
   */
  static readonly FormulaireGetCodesAccesVisiteurPpPath = '/api/formulaires/codes-acces-visiteur-pp';

  /**
   * Génère le formulaire contenant les codes d'accès d'une personne physique.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetCodesAccesVisiteurPp()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetCodesAccesVisiteurPp$Response(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetCodesAccesVisiteurPpPath, 'get');
    if (params) {
      rb.query('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.query('langue', params.langue, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le formulaire contenant les codes d'accès d'une personne physique.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetCodesAccesVisiteurPp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetCodesAccesVisiteurPp(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<Blob> {

    return this.formulaireGetCodesAccesVisiteurPp$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintCodesAccesVisiteurPp
   */
  static readonly FormulairePrintCodesAccesVisiteurPpPath = '/api/formulaires/print-codes-acces-visiteur-pp';

  /**
   * Imprime le formulaire contenant les codes d'accès d'une personne physique.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintCodesAccesVisiteurPp()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintCodesAccesVisiteurPp$Response(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintCodesAccesVisiteurPpPath, 'post');
    if (params) {
      rb.query('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.query('langue', params.langue, {});
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le formulaire contenant les codes d'accès d'une personne physique.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintCodesAccesVisiteurPp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintCodesAccesVisiteurPp(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintCodesAccesVisiteurPp$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation formulaireGetCodesAccesVisiteurPm
   */
  static readonly FormulaireGetCodesAccesVisiteurPmPath = '/api/formulaires/codes-acces-visiteur-pm';

  /**
   * Génère le formulaire contenant les codes d'accès d'une personne morale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetCodesAccesVisiteurPm()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetCodesAccesVisiteurPm$Response(params?: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetCodesAccesVisiteurPmPath, 'get');
    if (params) {
      rb.query('personneMoraleId', params.personneMoraleId, {});
      rb.query('langue', params.langue, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le formulaire contenant les codes d'accès d'une personne morale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetCodesAccesVisiteurPm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetCodesAccesVisiteurPm(params?: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<Blob> {

    return this.formulaireGetCodesAccesVisiteurPm$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintCodesAccesVisiteurPm
   */
  static readonly FormulairePrintCodesAccesVisiteurPmPath = '/api/formulaires/print-codes-acces-visiteur-pm';

  /**
   * Imprime le formulaire contenant les codes d'accès d'une personne morale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintCodesAccesVisiteurPm()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintCodesAccesVisiteurPm$Response(params?: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintCodesAccesVisiteurPmPath, 'post');
    if (params) {
      rb.query('personneMoraleId', params.personneMoraleId, {});
      rb.query('langue', params.langue, {});
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le formulaire contenant les codes d'accès d'une personne morale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintCodesAccesVisiteurPm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintCodesAccesVisiteurPm(params?: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintCodesAccesVisiteurPm$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation formulaireGetRachatQuotaGlobalPp
   */
  static readonly FormulaireGetRachatQuotaGlobalPpPath = '/api/formulaires/rachat-quota-global-pp';

  /**
   * Génère le formulaire de rachat de quota global pour une personne physique.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetRachatQuotaGlobalPp()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetRachatQuotaGlobalPp$Response(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Identifiant de la demande de quota ou 0 pour en créer une nouvelle
     */
    demandeQuotaId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetRachatQuotaGlobalPpPath, 'get');
    if (params) {
      rb.query('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.query('demandeQuotaId', params.demandeQuotaId, {});
      rb.query('langue', params.langue, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le formulaire de rachat de quota global pour une personne physique.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetRachatQuotaGlobalPp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetRachatQuotaGlobalPp(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Identifiant de la demande de quota ou 0 pour en créer une nouvelle
     */
    demandeQuotaId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<Blob> {

    return this.formulaireGetRachatQuotaGlobalPp$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintRachatQuotaGlobalPp
   */
  static readonly FormulairePrintRachatQuotaGlobalPpPath = '/api/formulaires/print-rachat-quota-global-pp';

  /**
   * Imprime le formulaire de rachat de quota global pour une personne physique.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintRachatQuotaGlobalPp()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintRachatQuotaGlobalPp$Response(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Identifiant de la demande de quota ou 0 pour en créer une nouvelle
     */
    demandeQuotaId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintRachatQuotaGlobalPpPath, 'post');
    if (params) {
      rb.query('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.query('demandeQuotaId', params.demandeQuotaId, {});
      rb.query('langue', params.langue, {});
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le formulaire de rachat de quota global pour une personne physique.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintRachatQuotaGlobalPp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintRachatQuotaGlobalPp(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Identifiant de la demande de quota ou 0 pour en créer une nouvelle
     */
    demandeQuotaId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintRachatQuotaGlobalPp$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation formulaireGetRachatQuotaGlobalPm
   */
  static readonly FormulaireGetRachatQuotaGlobalPmPath = '/api/formulaires/rachat-quota-global-pm';

  /**
   * Génère le formulaire de rachat de quota global pour une personne morale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetRachatQuotaGlobalPm()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetRachatQuotaGlobalPm$Response(params?: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId?: number;

    /**
     * Identifiant de la demande de quota ou 0 pour en créer une nouvelle
     */
    demandeQuotaId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetRachatQuotaGlobalPmPath, 'get');
    if (params) {
      rb.query('personneMoraleId', params.personneMoraleId, {});
      rb.query('demandeQuotaId', params.demandeQuotaId, {});
      rb.query('langue', params.langue, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le formulaire de rachat de quota global pour une personne morale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetRachatQuotaGlobalPm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetRachatQuotaGlobalPm(params?: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId?: number;

    /**
     * Identifiant de la demande de quota ou 0 pour en créer une nouvelle
     */
    demandeQuotaId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<Blob> {

    return this.formulaireGetRachatQuotaGlobalPm$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintRachatQuotaGlobalPm
   */
  static readonly FormulairePrintRachatQuotaGlobalPmPath = '/api/formulaires/print-rachat-quota-global-pm';

  /**
   * Imprime le formulaire de rachat de quota global pour une personne morale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintRachatQuotaGlobalPm()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintRachatQuotaGlobalPm$Response(params?: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId?: number;

    /**
     * Identifiant de la demande de quota ou 0 pour en créer une nouvelle
     */
    demandeQuotaId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintRachatQuotaGlobalPmPath, 'post');
    if (params) {
      rb.query('personneMoraleId', params.personneMoraleId, {});
      rb.query('demandeQuotaId', params.demandeQuotaId, {});
      rb.query('langue', params.langue, {});
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le formulaire de rachat de quota global pour une personne morale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintRachatQuotaGlobalPm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintRachatQuotaGlobalPm(params?: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId?: number;

    /**
     * Identifiant de la demande de quota ou 0 pour en créer une nouvelle
     */
    demandeQuotaId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintRachatQuotaGlobalPm$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation formulaireGetDemandeAccesResidentHorsZoneIc
   */
  static readonly FormulaireGetDemandeAccesResidentHorsZoneIcPath = '/api/formulaires/demande-acces-resident-hors-zone-ic';

  /**
   * Génère le formulaire de demande d'accès pour un résident hors zone IC.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetDemandeAccesResidentHorsZoneIc()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetDemandeAccesResidentHorsZoneIc$Response(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetDemandeAccesResidentHorsZoneIcPath, 'get');
    if (params) {
      rb.query('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.query('langue', params.langue, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le formulaire de demande d'accès pour un résident hors zone IC.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetDemandeAccesResidentHorsZoneIc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetDemandeAccesResidentHorsZoneIc(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<Blob> {

    return this.formulaireGetDemandeAccesResidentHorsZoneIc$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintDemandeAccesResidentHorsZoneIc
   */
  static readonly FormulairePrintDemandeAccesResidentHorsZoneIcPath = '/api/formulaires/print-demande-acces-resident-hors-zone-ic';

  /**
   * Imprime le formulaire de demande d'accès pour un résident hors zone IC.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintDemandeAccesResidentHorsZoneIc()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintDemandeAccesResidentHorsZoneIc$Response(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintDemandeAccesResidentHorsZoneIcPath, 'post');
    if (params) {
      rb.query('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.query('langue', params.langue, {});
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le formulaire de demande d'accès pour un résident hors zone IC.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintDemandeAccesResidentHorsZoneIc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintDemandeAccesResidentHorsZoneIc(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintDemandeAccesResidentHorsZoneIc$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation formulaireGetDemandeAccesEtranger
   */
  static readonly FormulaireGetDemandeAccesEtrangerPath = '/api/formulaires/demande-acces-etranger';

  /**
   * Génère le formulaire de demande d'accès pour un étranger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetDemandeAccesEtranger()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetDemandeAccesEtranger$Response(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetDemandeAccesEtrangerPath, 'get');
    if (params) {
      rb.query('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.query('langue', params.langue, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le formulaire de demande d'accès pour un étranger.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetDemandeAccesEtranger$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetDemandeAccesEtranger(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;
  }): Observable<Blob> {

    return this.formulaireGetDemandeAccesEtranger$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintDemandeAccesEtranger
   */
  static readonly FormulairePrintDemandeAccesEtrangerPath = '/api/formulaires/print-demande-acces-etranger';

  /**
   * Imprime le formulaire de demande d'accès pour un étranger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintDemandeAccesEtranger()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintDemandeAccesEtranger$Response(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintDemandeAccesEtrangerPath, 'post');
    if (params) {
      rb.query('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.query('langue', params.langue, {});
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le formulaire de demande d'accès pour un étranger.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintDemandeAccesEtranger$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintDemandeAccesEtranger(params?: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId?: number;

    /**
     * Langue du formulaire
     */
    langue?: Langues;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintDemandeAccesEtranger$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation formulaireGetDemandeTransport
   */
  static readonly FormulaireGetDemandeTransportPath = '/api/formulaires/demande-transport';

  /**
   * Génère le formulaire de demande de transport.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetDemandeTransport()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetDemandeTransport$Response(params?: {

    /**
     * Identifiant de la demande de transport
     */
    demandeTransportId?: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetDemandeTransportPath, 'get');
    if (params) {
      rb.query('demandeTransportId', params.demandeTransportId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le formulaire de demande de transport.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetDemandeTransport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetDemandeTransport(params?: {

    /**
     * Identifiant de la demande de transport
     */
    demandeTransportId?: number;
  }): Observable<Blob> {

    return this.formulaireGetDemandeTransport$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintDemandeTransport
   */
  static readonly FormulairePrintDemandeTransportPath = '/api/formulaires/print-demande-transport';

  /**
   * Imprime le formulaire de demande de transport.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintDemandeTransport()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintDemandeTransport$Response(params?: {

    /**
     * Identifiant de la demande de transport
     */
    demandeTransportId?: number;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintDemandeTransportPath, 'post');
    if (params) {
      rb.query('demandeTransportId', params.demandeTransportId, {});
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le formulaire de demande de transport.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintDemandeTransport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintDemandeTransport(params?: {

    /**
     * Identifiant de la demande de transport
     */
    demandeTransportId?: number;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintDemandeTransport$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation formulaireGetDemandeTransportVide
   */
  static readonly FormulaireGetDemandeTransportVidePath = '/api/formulaires/demande-transport-vide';

  /**
   * Génère le formulaire de demande de transport vide.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetDemandeTransportVide()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetDemandeTransportVide$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetDemandeTransportVidePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le formulaire de demande de transport vide.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetDemandeTransportVide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetDemandeTransportVide(params?: {
  }): Observable<Blob> {

    return this.formulaireGetDemandeTransportVide$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintDemandeTransportVide
   */
  static readonly FormulairePrintDemandeTransportVidePath = '/api/formulaires/print-demande-transport-vide';

  /**
   * Imprime le formulaire de demande de transport vide.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintDemandeTransportVide()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintDemandeTransportVide$Response(params?: {

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintDemandeTransportVidePath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le formulaire de demande de transport vide.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintDemandeTransportVide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintDemandeTransportVide(params?: {

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintDemandeTransportVide$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation formulaireGetBonCommande
   */
  static readonly FormulaireGetBonCommandePath = '/api/formulaires/bon-commande';

  /**
   * Génère le bon de commande.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireGetBonCommande()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetBonCommande$Response(params?: {

    /**
     * Identifiant de la commande
     */
    commandeId?: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulaireGetBonCommandePath, 'get');
    if (params) {
      rb.query('commandeId', params.commandeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Génère le bon de commande.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireGetBonCommande$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireGetBonCommande(params?: {

    /**
     * Identifiant de la commande
     */
    commandeId?: number;
  }): Observable<Blob> {

    return this.formulaireGetBonCommande$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation formulairePrintBonCommande
   */
  static readonly FormulairePrintBonCommandePath = '/api/formulaires/print-bon-commande';

  /**
   * Imprime le bon de commande.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulairePrintBonCommande()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintBonCommande$Response(params?: {

    /**
     * Identifiant de la commande
     */
    commandeId?: number;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesService.FormulairePrintBonCommandePath, 'post');
    if (params) {
      rb.query('commandeId', params.commandeId, {});
      rb.query('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Imprime le bon de commande.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulairePrintBonCommande$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulairePrintBonCommande(params?: {

    /**
     * Identifiant de la commande
     */
    commandeId?: number;

    /**
     * Identifiant du recyparc sur lequel l&#x27;impression doit être envoyée (0 pour détecter le recyparc en fonction du profil de l&#x27;utilisateur)
     */
    parcId?: number;
  }): Observable<boolean> {

    return this.formulairePrintBonCommande$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
